import { Axios } from "../../../util";

const getPolicyCouponAPI = async (policyNo) => {
  try {
    // const res = await Axios.post("/api/policy/policyInformation");
    const res = await Axios.post(
      `/api/policy/policyCoupon?policyNo=${policyNo}`
    );
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const uploadFileAPI = async (formData) => {
  try {
    // const res = await Axios.post("/api/policy/policyInformation");
    const res = await Axios.post(`/api/policy/upload`, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const requestOtpAPI = async (actionType = "") => {
  try {
    const res = await Axios.post(
      `/requestOTP`,
      {
        actionType: actionType
      },
      {
        headers: { accept: "application/json" },
      }
    );
    // console.log("data", res.data);

    // Check if response indicates too many requests (even with HTTP 200)
    if (res.data.success === false && res.data.payload?.error) {
      return {
        status: false,
        meg: res.data.payload.error
      };
    }

    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    // Handle 429 Too Many Requests (HTTP status)
    if (error.response && error.response.status === 429) {
      return {
        status: false,
        meg: error.response.data?.payload?.error ||
             error.response.data?.meg ||
             error.response.data?.message ||
             "คุณส่ง OTP บ่อยเกินไป กรุณารอสักครู่แล้วลองใหม่อีกครั้ง"
      };
    }
    throw error;
  }
};

const verifyChangeBankAPI = async (data) => {
  try {
    const formData = new FormData();
    formData.append("bank_account_file", data.bank_account_file[0]);
    formData.append("bank_account", data.bank_account);
    formData.append("bank_account_file_name", data.bank_account_file_name);
    formData.append(
      "bank_account_flag_information",
      data.bank_account_flag_information
    );
    formData.append("bank_account_name", data.bank_account_name);
    formData.append("bank_name", data.bank_name);
    formData.append("otp", data.otp);
    formData.append("policy", data.policy);
    const res = await Axios.post(`/verifyOTP`, formData, {
      headers: {
        "content-type": "multipart/form-data",
        accept: "application/json",
      },
    });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const verifyChangePromptPayAPI = async (data) => {
  try {
    // รวมให้เป็นอาเรย์ ไม่ว่าจะส่งมาแบบ policy (เดี่ยว) หรือ policyNos (หลายตัว)
    const policies =
      Array.isArray(data.policyNos) ? data.policyNos :
      Array.isArray(data.policy) ? data.policy :
      data.policy ? [data.policy] : [];

    const payload = {
      otp: data.otp,
      policy: policies, // << ส่งเป็น array
      prompt_pay_account_name: data.prompt_pay_account_name?.trim() || "",
      prompt_pay_account: data.prompt_pay_account,
      prompt_pay_flag_information: !!data.prompt_pay_flag_information,
    };

    const res = await Axios.post("/verifyOTPPromptPay", payload);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const getInfomationAPI = async () => {
  try {
    const res = await Axios.get(
      `api/policy/getInformationNotPolicies`,
      {
        headers: { accept: "application/json" },
      }
    );
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

export {
  getPolicyCouponAPI,
  uploadFileAPI,
  requestOtpAPI,
  verifyChangeBankAPI,
  verifyChangePromptPayAPI,
  getInfomationAPI,
};
